import React, { useContext } from 'react';
import StickyNavigation from '@/components/StickyNavigationRebrand/StickyNavigation';
import Layout from '@/components/layout';
import PageData from '../data/pages/mobile-app.json';
import { PageContext } from '@/context/PageContext';
import Section from '@latitude/section';
import HeroV2 from '@/components/Hero/HeroV2/HeroV2';
import HeroBranded from '@/components/HeroBrandedRebrand/HeroBrandedRebrand';
import FeatureGridV1 from '@/components/FeatureGridV1/FeatureGridV1';
import SvgInline from '@latitude/svg-inline';
import Typography from '@latitude/typography';
import { BUTTON_STYLE, PADDING, REBRAND_COLOR } from '@latitude/core/utils/constants';
import { Box } from '@latitude/box';
import { Link } from '@latitude/link';
import PromoBanner from '@/components/PromoBannerRebrand/PromoBannerRebrand';
import AppPreview from '../images/app-preview.webp'
import { StyledImageContainer, StyledPromoBannerContainer, StyledTextContainer, Wrapper } from '../components/PromoBannerRebrand/PromoBannerRebrand.styled';
import { RewardsCarasoule } from '@/components/RewardsCarasoule/RewardsCarasoule';

const MobileApp = props => {
  /** Contentful Data */
  const contentfulPageData = useContext(PageContext);
  const state = contentfulPageData?.updatedBody || {};


  const FEATURE_GRID_DATA = {
    features: [
      {
        icon: <SvgInline name="icon-seal-percent-rebrand" />,
        headingText: 'Activate your card and change your PIN anytime',
        paragraphText: (
          <>
            To activate your card, find out more <a href='https://gemfinance.zendesk.com/hc/en-nz/articles/360008350157-Activate-Your-Card?_gl=1*1gdfpb8*_gcl_au*NjgzNTgyMjcyLjE3NzQ0ODI1MjU.*_ga*MTY1OTI3ODIxNi4xNzc5MTYxMTc2*_ga_S8DT26C3G4*czE3ODEyMzkzNDkkbzUkZzEkdDE3ODEyMzkzODUkajI0JGwwJGgxOTA3MzUxMjQx*_ga_ZXRZ5ZKK5R*czE3ODEyMzkzNDkkbzUkZzEkdDE3ODEyMzkzODUkajI0JGwwJGgxODM0NjcyMzg1'>here</a>.
          </>
        )
      },
      {
        icon: <SvgInline name="icon-hand-coins-rebrand" />,
        headingText: 'View your balance and transactions instantly',
        paragraphText: (
          <>
            Keep your spending on track.
          </>
        )
      },
      {
        icon: <SvgInline name="icon-package-rebrand" />,
        headingText: 'Access your eStatements',
        paragraphText: (
          <>
            All in one handy place.
          </>
        )
      },
      {
        icon: <SvgInline name="icon-lock-rebrand" />,
        headingText: 'Temporarily lock your card',
        paragraphText: (
          <>
            One less worry if you lose your wallet.
          </>
        )
      },
      {
        icon: <SvgInline name="icon-device-mobile-rebrand" />,
        headingText: 'Update your address',
        paragraphText: (
          <>
            Keeping your details up to date helps us get in touch with you.
          </>
        )
      },
      {
        icon: <SvgInline name="icon-users-rebrand" />,
        headingText: 'Report a lost, stolen or damaged card',
        paragraphText: (
          <>
            We’ll cancel your card, send you a replacement and update your digital wallet automatically to get you going straight away.
          </>
        )
      }
    ]
  };

  const PAGE_NAVIGATION = [
    {
      anchor: 'features',
      label: 'What you get'
    },
    {
      anchor: 'download-app',
      label: 'Download the App'
    },
    {
      anchor: 'faq',
      label: 'FAQs'
    }
  ];



  return (
    <Layout location={props.location}>
      <main
        className="navigation-spacer"
        css={`
          background: #fff;
          div.lfs-features-slider {
            padding: 0;
          }
          div.lfs-card {
            @media (max-width: 576px) {
              flex-direction: column;
            }
          }
          div.lfs-card-icon {
            width: 70px !important;
            height: 70px !important;
          }
          .lfs-card-heading {
            @media (min-width: 576px) {
              height: 64px;
            }
          }

          #features .slick-dots {
            top: 0;
          }
        `}
      >

        <HeroV2 {...state?.heroBannerData?.[0] || PageData?.heroBannerData?.[0]} />

        <div css={`
          @media (min-width: 768px) {
              div[class*='FeatureGridstyled__StyledMainGrid-'] {
                  grid-template-columns: repeat(3, 1fr) !important;
              }
          }
          `}>
          <FeatureGridV1
            id="features"
            title={<Typography.H4>Features and benefits</Typography.H4>}
            trackingId="mobile-app"
            {...FEATURE_GRID_DATA}
          />
        </div>

        <AppSection
          id="app"
          backgroundColor="white"
        />

        <RewardsCarasoule
          id="app-instruction"
          title="Get started now"
          subtitle=""
          rewards={[
            {
              imageUrl: require('../images/app-icon-group.webp'),
              title: 'Step 1',
              description: (
                <span>
                  Download or open the Latitude App
                </span>
              )
            },
            {
              imageUrl: require('../images/latitude-box-id.webp'),
              title: 'Step 2',
              description:
                (<>Create your Latitude ID</>)
            },
            {
              imageUrl: require('../images/app-account-preview.webp'),
              title: 'Step 3',
              description: (<>Link your cards and manage your finances at the touch of a button!</>)
            }
          ]}
        />

        <HeroBranded 
          id="download-app" 
          heading={<>Download the Latitude credit card app</>}
          body={<>Manage your account, make payments and track your purchases in just a few taps with our mobile app.</>}
        />

        <Section
          className='bg-white'
          css={`
            text-align:center;
            padding-top: 64px;
            padding-bottom: 64px;
            `}
        >
          <Typography.H4>
            We’re here to help
          </Typography.H4>

          <div css={`
            padding-top: 8px;
            `}>
            <Typography.Body>
              For more information and useful help request forms.
            </Typography.Body>
          </div>
          <Box paddingTop={PADDING.P24} css={`
              width: 100%;
              display: flex;
              justify-content: center;
              `}>
            <div
              css={`
                                  
              a[class*='Linkstyled__StyledLink-'] {
                padding: 10px;
                line-height: 14px;
                background-color: ${REBRAND_COLOR.WHITE} !important;
                border-color: ${REBRAND_COLOR.INDIGO} !important;
                 max-width: 220px !important;
              }
                  `}
            >
              <Link
                button={BUTTON_STYLE.SECONDARY}
                href="https://gemfinance.zendesk.com/hc/en-nz/categories/360003424158-Latitude-Mobile-App?gemid2=gemf-web%3Ainformation%3Amobile-app%3Avisit-our-help-centre%3Awere-here-to-help&_gl=1*vgxj0m*_gcl_au*MTc3Njc4ODE5NC4xNzc1MDE0MzE4*_ga*MTYxNjcxOTY3NC4xNzMyNTkzMjY1*_ga_S8DT26C3G4*czE3ODEyNDA0MzQkbzE0MyRnMSR0MTc4MTI0MDQ3NyRqMTckbDAkaDQ3NDE3MDAyOA..*_ga_ZXRZ5ZKK5R*czE3ODEyNDA0MzYkbzE0MiRnMSR0MTc4MTI0MDQ3NyRqMTkkbDAkaDIxMDM4MzIzMTc.&tlga=1616719674.1732593265"
                trackId="callout-call-btn"
                trackEventData={{
                  label: 'get-accredited',
                  location: 'callout-call-btn',
                  action: 'internal-link',
                  category: 'cta'
                }}
              >
                <Typography.Body>
                  Visit our Help Centre
                </Typography.Body>

                <SvgInline name="arrow-square-out" />
              </Link>
            </div>
          </Box>
        </Section>
      </main>
    </Layout>
  );
};

const APP_SECTION_DATA = {
  image: {
    src: '../images/app-preview.webp',
    alt: 'Latitude app on a smartphone',
  },
  title: 'Take care of all your Latitude products in one easy to use app',
  body: 'Our easy to use app lets you take charge of your money, where you can view all your accounts, transactions, payments and timelines in one go.',
};



const AppSection = ({ trackingId, backgroundColor = 'white', ...rest }) => {


  return (
    <Wrapper
      className={` bg-${backgroundColor.toLowerCase()}`}
      {...rest}
    >
      <StyledPromoBannerContainer isReversed={true}>
        <StyledImageContainer fullWidth={false}>
          <img
            src={AppPreview}
            alt={APP_SECTION_DATA.image.alt}
          />
        </StyledImageContainer>
        <StyledTextContainer fullWidth={false} css={`
          @media (min-width: 768px) {
        padding-left: 48px !important;
    
}
          `}>
          <Typography.SH1 semibold>{APP_SECTION_DATA.title}</Typography.SH1>
          <Typography.Body>{APP_SECTION_DATA.body}</Typography.Body>
        </StyledTextContainer>
      </StyledPromoBannerContainer>
    </Wrapper>
  );
};

export default MobileApp;
